import Select from './Select.svelte';
export * from './Select.types.js';
import OptionComponent from './Option.svelte';
export * from './Option.types.js';
const Option = OptionComponent;
export default Select;
export { Option };
//# sourceMappingURL=index.js.map